import { AlpineComponent } from 'alpinejs';

const FileUpload = (): AlpineComponent => ({
  onChangeInput() {
    const uploadedFiles = this.$refs.input.files;

    if (uploadedFiles.length > 0) {
      const fileNames = [];
      for (let i = 0; i < uploadedFiles.length; i += 1) {
        const file = uploadedFiles[i];
        fileNames.push(file.name);
      }

      this.$refs.files.textContent = fileNames.join(', ');
      this.$refs.files.removeAttribute('hidden');
      this.$refs.placeholder.setAttribute('hidden', '');
    } else {
      this.$refs.placeholder.removeAttribute('hidden');
      this.$refs.files.setAttribute('hidden', '');
    }
  }
});

export default FileUpload;
